import { listAllAutocompleteSuppliers, listAllAutocompleteSuppliersNext } from '../thunks/autocomplete-suppliers';
import { handlePending, handleRejected } from './utils';

export const autocompleteSuppliersReducers = (builder) => {
  // List all suppliers
  builder
    .addCase(listAllAutocompleteSuppliers.fulfilled, (state, action) => {
      const files = action.payload?.data || [];
      const offset = action.payload?.offset || 0;
      state.autocompleteSuppliers.value = files;
      state.autocompleteSuppliers.offset = offset;
      state.autocompleteSuppliers.hasMore = files.length > 0;
      state.autocompleteSuppliers.loading = false;
    })
    .addCase(listAllAutocompleteSuppliers.pending, (state) => handlePending(state, 'autocompleteSuppliers'))
    .addCase(listAllAutocompleteSuppliers.rejected, (state) => handleRejected(state, 'autocompleteSuppliers'));

  // List all suppliers next
  builder
    .addCase(listAllAutocompleteSuppliersNext.fulfilled, (state, action) => {
      const files = action.payload?.data || [];
      const offset = action.payload?.offset || 0;
      state.autocompleteSuppliers.value = [...state.autocompleteSuppliers.value, ...files];
      state.autocompleteSuppliers.offset = offset;
      state.autocompleteSuppliers.hasMore = files.length > 0;
      state.autocompleteSuppliers.loading = false;
    })
    .addCase(listAllAutocompleteSuppliersNext.pending, (state) => handlePending(state, 'autocompleteSuppliers'))
    .addCase(listAllAutocompleteSuppliersNext.rejected, (state) => handleRejected(state, 'autocompleteSuppliers'));
};
